import React, { useState } from 'react';
import analytics from 'storefront-analytics/dist/analytics';
import '@chewy/pet-profile-form/dist/esm/main.css';
import { AnalyticsData } from '@chewy/pet-profile-form/dist/esm/packages/pet-profile-form/src/types';
import PetProfileForm from '@chewy/pet-profile-form';
import { KibInputText, KibInputSelect } from '@chewy/kib-fields-react';
import '@chewy/kib-fields-styles/dist/styles/kib-input-text.css';
import '@chewy/kib-fields-styles/dist/styles/kib-input-select.css';
import { KibButtonNew } from '@chewy/kib-controls-react';
import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css';
import './form-page.scss';
import { useHistory } from 'react-router-dom';
import useLocationQuery from '../../hooks/useLocationQuery';
import { formPath } from '../../util/config';
import { conditionalHistoryPush } from '../../util/helpers';
import '@chewy/kib-overlays-styles/dist/styles/kib-sheet.css';
import '@chewy/kib-transition-styles/dist/kib-transition.css';

export default function FormPage() {
  const usecaseOptions: string[] = [
    ' ',
    'basic',
    'test',
    'pharmacy',
    'vetDiet',
    'cwav',
    'insurance',
  ];

  const history = useHistory();
  const query = useLocationQuery();

  const usecaseParam = query.get('usecase');
  const profileIdParam = query.get('petProfileId');
  const usecase = usecaseParam && usecaseOptions.includes(usecaseParam) ? usecaseParam : undefined;
  const profileId = profileIdParam ? Number.parseInt(profileIdParam) : undefined;

  const [idInput, setIdInput] = useState<string>(profileIdParam || '');
  const [usecaseInput, setUsecaseInput] = useState<string>(usecaseParam || ' ');

  const getPath = (
    basePath: string,
    id: string | undefined,
    usecase: string | undefined,
  ): string => {
    let queryParams: string[] = [];
    if (id) {
      queryParams.push(`petProfileId=${id}`);
    }
    if (usecase && usecase !== ' ') {
      queryParams.push(`usecase=${usecase}`);
    }

    return `${basePath}?${queryParams.join('&')}`;
  };

  const onApply = () => {
    conditionalHistoryPush(getPath(formPath, idInput, usecaseInput), history);
  };

  return (
    <div className="testing-page">
      <div className="testing-page__inputs">
        <KibInputText
          label="profileId"
          onChange={(event) => setIdInput(event.target.value)}
          value={idInput}
        />
        <KibInputSelect
          label="usecase"
          options={usecaseOptions}
          value={usecaseInput}
          onChange={(event) => setUsecaseInput(event.target.value)}
        />
        <KibButtonNew onClick={() => onApply()}>Apply</KibButtonNew>
      </div>
      <hr />
      <PetProfileForm
        petProfileId={profileId}
        usecase={usecase}
        analytics={{
          segmentTrack: (event: string, data: AnalyticsData) => {
            const noOfEvents =
              (document.querySelector('#segment-logs')?.innerHTML.match(/\n/g)?.length || 0) + 1;
            document
              .querySelector('#segment-logs')
              ?.append(`\n[${noOfEvents}] ${event} ${JSON.stringify(data)}`);
            analytics.segmentTrack(event, data);
          },
        }}
      />
      <hr />
      <div className="form-page__footer">
        <span>
          {'API Response: '}
          <a
            target="_blank"
            rel="noreferrer"
            href={`/${getPath(`api/petprofile/v2/pets/form`, profileId?.toString(), usecase)}`}
          >{`GET /${getPath(`api/petprofile/v2/pets/form`, profileId?.toString(), usecase)}`}</a>
        </span>
        <p>Segment Logs from Form Component:</p>
        <pre id="segment-logs" />
      </div>
    </div>
  );
}
